var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from 'shared/assets/icons';
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, } from 'shared/components/ui';
import { useLogout } from 'shared/hooks/';
export var Logout = function (_a) {
    var isLogoutOpen = _a.isLogoutOpen, onLogoutClose = _a.onLogoutClose;
    var logout = useLogout();
    var handleLogout = function () {
        onLogoutClose();
        logout();
    };
    return (_jsxs(Modal, __assign({ id: "logout-modal", variant: "confirm", size: "md", isOpen: isLogoutOpen, onClose: onLogoutClose }, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { children: [_jsxs(ModalHeader, __assign({ "data-testid": "logoutModalHeader" }, { children: ["Sign Out?", _jsx(ModalCloseButton, { "data-testid": "logoutModalCloseButton", as: Close })] })), _jsx(ModalBody, __assign({ "data-testid": "logoutModalBody" }, { children: "Are you sure you want to sign out?" })), _jsxs(ModalFooter, { children: [_jsx(Button, __assign({ "data-testid": "staySignedInButton", variant: "secondary", onClick: onLogoutClose }, { children: "Stay Signed In" })), _jsx(Button, __assign({ "data-testid": "signOutButton", onClick: handleLogout }, { children: "Sign Out" }))] })] })] })));
};
